import { connect } from 'react-redux';
import type { RootState } from '../../../../configuration/setup/store';
import type { AssetsThunkDispatch } from '../../actions/assets/types';
import { FilterOptionsDialog } from '../../components/assets/FilterOptionsDialog';
import type {
    FilterOptionsDialogPropertiesFromDispatch,
    FilterOptionsDialogPropertiesFromState,
} from '../../components/assets/types';
import {
    assetTableApplyFilterChanges,
    filterOptionsDialogClose,
    getShowActiveAssets,
    getShowArchivedAssets,
    getShowFilterOptionsDialog,
    getShowOnlyAssetsWithoutDataSource,
} from '../../reducers/assets/assetsSlice';

function mapDispatchToProps(dispatch: AssetsThunkDispatch): FilterOptionsDialogPropertiesFromDispatch {
    return {
        onClose: () => dispatch(filterOptionsDialogClose()),
        applyFilterChanges: (filterActive: boolean, showActiveAssets: boolean, showArchivedAssets: boolean) =>
            dispatch(
                assetTableApplyFilterChanges({
                    showOnlyAssetsWithoutDataSources: filterActive,
                    showActiveAssets,
                    showArchivedAssets,
                })
            ),
    };
}

function mapStateToProps(state: RootState): FilterOptionsDialogPropertiesFromState {
    return {
        show: getShowFilterOptionsDialog(state),
        showOnlyAssetsWithoutDataSource: getShowOnlyAssetsWithoutDataSource(state),
        showActiveAssets: getShowActiveAssets(state),
        showArchivedAssets: getShowArchivedAssets(state),
    };
}

const FilterOptionsDialogContainer = connect(mapStateToProps, mapDispatchToProps)(FilterOptionsDialog);

export default FilterOptionsDialogContainer;
